import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=11179a3a&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=11179a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11179a3a",
  null
  
)

export default component.exports